import api from '@/services/api'

/**
 * Global Loading State Composable
 * Provides access to the centralized loading state managed by the API layer
 */
export function useGlobalLoading() {
  // Get the reactive loading state from API service
  const isLoading = api.getLoadingState()
  
  // Get active requests count (for debugging)
  const getActiveRequestsCount = () => api.getActiveRequestsCount()
  
  // Reset loading state (for debugging/recovery)
  const resetLoadingState = () => api.resetLoadingState()
  
  // Get debug info
  const getLoadingDebugInfo = () => api.getLoadingDebugInfo()
  
  return {
    isLoading,
    getActiveRequestsCount,
    resetLoadingState,
    getLoadingDebugInfo
  }
}
